import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/auth'
import Events from './modules/events'
import Dependants from './modules/dependants'
import Lookups from './modules/lookups'
import Vouchers from './modules/vouchers'
import Users from './modules/users'
import TeamMembers from './modules/team-members'
import Workouts from './modules/workouts'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    Auth,
    Events,
    Dependants,
    Lookups,
    Vouchers,
    Users,
    TeamMembers,
    Workouts
  }
})

export default store
